"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MigrateService", {
    enumerable: true,
    get: function() {
        return MigrateService;
    }
});
const _stream = require("stream");
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _common = require("@nestjs/common");
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _ncError = require("~/helpers/ncError");
const _exportservice = require("~/modules/jobs/jobs/export-import/export.service");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let MigrateService = class MigrateService {
    async migrateBase({ context, base, source, secret, instanceUrl }) {
        var _axiosRes_response;
        if (!base) {
            _ncError.NcError.get(context).baseNotFound('Base not found!');
        }
        if (!source) {
            _ncError.NcError.get(context).sourceNotFound('Source not found!');
        }
        const models = (await source.getModels(context)).filter((m)=>m.source_id === source.id && !m.mm && m.type === 'table');
        const { serializedModels: exportedModels } = await this.exportService.serializeModels(context, {
            modelIds: models.map((m)=>m.id),
            compatibilityMode: source.type !== 'pg'
        });
        if (!exportedModels) {
            _ncError.NcError.get(context).baseError('Export failed for source ' + source.id);
        }
        const exportedUsers = await this.exportService.serializeUsers(context, {
            baseId: base.id
        });
        const stream = new _stream.Readable({
            read () {}
        });
        const pushStream = (data)=>{
            if (data === null) {
                stream.push(null);
                return;
            }
            stream.push(JSON.stringify(data));
        };
        const axiosPromise = (0, _axios.default)({
            method: 'post',
            url: `${instanceUrl}/api/v2/meta/duplicate/remote/${secret}`,
            headers: {
                'Content-Type': 'application/octet-stream'
            },
            data: stream,
            maxBodyLength: Infinity
        }).catch((e)=>{
            pushStream(null);
            return e;
        });
        pushStream({
            type: 'base',
            data: {
                title: base.title,
                meta: base.meta
            }
        });
        pushStream({
            type: 'users',
            data: exportedUsers
        });
        pushStream({
            type: 'schema',
            data: exportedModels
        });
        let error = null;
        const handledLinks = [];
        for (const sourceModel of models){
            if (error) break;
            const dataStream = new _stream.Readable({
                read () {}
            });
            const linkStream = new _stream.Readable({
                read () {}
            });
            this.exportService.streamModelDataAsCsv(context, {
                dataStream,
                linkStream,
                baseId: base.id,
                modelId: sourceModel.id,
                handledMmList: handledLinks
            }).catch((e)=>{
                this.debugLog(e);
                dataStream.push(null);
                linkStream.push(null);
                error = e;
            });
            const dataStreamPromise = new Promise((resolve, reject)=>{
                dataStream.on('data', (data)=>{
                    pushStream({
                        type: 'data',
                        modelId: sourceModel.id,
                        data
                    });
                });
                dataStream.on('end', ()=>{
                    pushStream({
                        type: 'data',
                        modelId: sourceModel.id,
                        data: null
                    });
                    resolve(null);
                });
                dataStream.on('error', (e)=>{
                    reject(e);
                });
            });
            const linkStreamPromise = new Promise((resolve, reject)=>{
                linkStream.on('data', (data)=>{
                    pushStream({
                        type: 'link',
                        modelId: sourceModel.id,
                        data
                    });
                });
                linkStream.on('end', ()=>{
                    pushStream({
                        type: 'link',
                        modelId: sourceModel.id,
                        data: null
                    });
                    resolve(null);
                });
                linkStream.on('error', (e)=>{
                    reject(e);
                });
            });
            await Promise.all([
                dataStreamPromise,
                linkStreamPromise
            ]);
        }
        pushStream(null);
        const axiosRes = await axiosPromise;
        return (axiosRes == null ? void 0 : (_axiosRes_response = axiosRes.response) == null ? void 0 : _axiosRes_response.data) || (axiosRes == null ? void 0 : axiosRes.data);
    }
    constructor(exportService){
        this.exportService = exportService;
        this.debugLog = (0, _debug.default)('nc:jobs:export');
    }
};
MigrateService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _exportservice.ExportService === "undefined" ? Object : _exportservice.ExportService
    ])
], MigrateService);
